import React, { useState } from "react";

const MyCheckBox = ({ data, setAnswer }) => {
  const [selectedValues, setSelectedValues] = useState(
    JSON.parse(data?.response_text)
  );

  const updateArray = (array = [], newValue) => {
    const index = array?.findIndex((value) => value === newValue);
    if (index !== -1) {
      return array?.filter((value) => value !== newValue);
    } else {
      return [...array, newValue];
    }
  };

  const checkStringInArray = (value) => {
    return selectedValues?.includes(value);
  };

  const onChange = (value) => {
    const values = updateArray(selectedValues || [], value);
    setSelectedValues(values);
    setAnswer(values);
  };

  return (
    <div className="flex flex-col gap-5">
      <div className="flex items-start gap-2">
        {data?.is_required === 1 && <p className="text-red-600 text-lg">*</p>}
        <p className="text-base text-center">{data?.field_label}</p>
      </div>

      <div className="w-full flex flex-wrap gap-5">
        {data?.options?.map((item, index) => (
          <div
            key={index}
            className={`py-3 px-12 font-medium border-2 rounded-md cursor-pointer duration-500 ${
              checkStringInArray(item)
                ? "text-primary border-primary bg-primaryLight"
                : "text-secondaryLight1"
            }`}
            onClick={() => onChange(item)}
          >
            {item}
          </div>
        ))}
      </div>
    </div>
  );
};

export default MyCheckBox;
